import { useMemo } from "react";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";

import { colorsByFunction, marketingColors } from "UI/colors";

const useHeaderTextColor = () => {
  const { isDark } = useMemberToobarContext();

  return useMemo(() => {
    if (isDark) return colorsByFunction.textLight;
    return colorsByFunction.textBlack;
  }, [isDark]);
};
const useCopyTextColor = () => {
  const { isDark } = useMemberToobarContext();

  return useMemo(() => {
    if (isDark) return colorsByFunction.textLight;
    return marketingColors.fnBlue;
  }, [isDark]);
};

export { useHeaderTextColor, useCopyTextColor };
